import React, { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next";
import './NuevaCadena.css';
import toast, { Toaster } from 'react-hot-toast';
import { MdClear } from "react-icons/md";
import CadenaService from '../../services/cadena.service';

const PopUpCadena = (props) => {
	
	const [nombre, setNombre] = useState('');
	const [selectedCadena, setSelectedCadena] = useState(null);
	const [t] = useTranslation("global");
	const [activo, setActivo] = useState(false)
	const [nombreError, setNombreError] = useState('');
	const toastGenericErrorLogin = () => toast.error(t('app.error.login.generic'));
	
	useEffect(() => {
		
		if(props.selectedCadena != null) {
			setNombre(props.selectedCadena.nombre);
			setActivo(props.selectedCadena.activo)
		}
		
		setSelectedCadena(props.selectedCadena)
		
	}, [props.selectedCadena])
	
	function handleLogin(e) {
		e.preventDefault()
		// Code to handle login goes here
		props.toggle()
	}
	
	function validateForm(cadena) {
		setNombreError('');
		
		if(cadena.nombre === '') {
			setNombreError(t('app.error.campoObligatorio'))
			return;
		}
		
		if(cadena.id != null) {
			updateCadena(cadena);
		} else {
			insertCadena(cadena);
		}
		
	}
	
	const insertCadena = async (cadena) => {
		await CadenaService.crearCadena(cadena)
		.then((response) => {
			if(response.status === 200) {
				// Close popup on insert success
					props.toggle();

					// Refresh table
					props.limpiarFiltros();
					props.loadCadenas();
			} else {
				toastGenericErrorLogin();
			}
		})
		.catch((err) => {
				toastGenericErrorLogin();
			});;
	}
	
	const updateCadena = async (cadena) => {
		await CadenaService.actualizarCadena(cadena)
		.then((response) => {
			if (response.status === 200) {
				props.toggle();
				
				if(props.filtroNombre != null || props.filtroActivo != null) {
					props.loadCadenasByParams(props.filtroNombre, props.filtroActivo);
				} else {
					props.limpiarFiltros();
					props.loadCadenas();
				}
				
			} else {
				toastGenericErrorLogin();
			}
		})
		.catch((err) => {
				toastGenericErrorLogin();
			});;
	}
	
	const crearCadena = async () => {
		const cadena = {
			nombre: nombre,
			activo: true
		}
		
		validateForm(cadena);
	}
	
	const editarCadena = async (selectedCadena) => {

		const cadena = {
			id: selectedCadena.id,
			nombre: nombre,
			activo: activo
		};

		validateForm(cadena);
	}
	
	const guardarCadena = async () => {
		if(selectedCadena != null) {
			editarCadena(selectedCadena);
		} else {
			crearCadena();
		}
	}
	
	const cancelarCadena = () => {

		// Close popup
		props.toggle();
	}
	
	return(
		<div className="popup">
			<div className="popup-inner">
				<div className="popup-Header">
					{selectedCadena != null ? <h1 className={"popup-Title"}>{t("app.cadena.edicionCadena")}</h1> : <h1 className={"popup-Title"}>{t("app.cadena.nuevaCadena")}</h1>}
					<button className="popup-btn-x" onClick={props.toggle}><MdClear /></button>
				</div>
				
				<div className="popup-Content">
					<form onSubmit={handleLogin}>
						<div className="popup-div-inputs-popup">
							<div className={'inputAndSelectContainerPopup'}>
								<input placeholder={t("app.cadena.popup.nombre")} type="text" value={nombre} onChange={e => setNombre(e.target.value)} />
								<label className="errorLabel">{nombreError}</label>
							</div>
						</div>
						
						{selectedCadena != null ? (
								<div className={'checkboxContainerCadena'}>
									<label>{t("app.popup.label.activo")}</label>
									<input type='checkbox' id='checkboxActivo' checked={activo} onChange={e => setActivo(e.target.checked)} />
								</div>
							) : null}
						
						<div className="popup-div-buttons">
							<button type="button" className="btn-general-colorPink" onClick={cancelarCadena}>{t("app.label.cancelar")}</button>
							<button type="button" className="btn-general" onClick={guardarCadena}>{t("app.label.guardar")}</button>
							<Toaster />
						</div>
					</form>
				</div>
			</div>
		</div>
	)
}

export default PopUpCadena